import Slider from "react-slick";
import styles from "../GlobalBanner/GlobalBanner.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useState, useEffect, useRef } from "react";
import { selectSliderElementsGen } from "@/helpers/generalHelper";

const GlobalBannerCarousel = (props) => {
  let settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 350,
    autoplaySpeed: 3500,
    arrows: false,
    fade:props.transitionType=='Fade'?true:false
  }
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  const sliderRef= useRef(null); 
  const [tabPressed, setTabPressed] = useState(false);

  // to handle global banner tab indexing
    useEffect(() => {
      // If the view is mobile, exit early
      if (isMobile) return;

      // Function to handle key events
      const handleKeyEvent = (event) => {
        try {
          switch (event?.key) {
            case "Tab":
              setTabPressed(event.type === "keydown");
              if (event.type === "keydown" && !tabPressed) {
                selectSliderElementsGen(sliderRef, true); // General function to select slider elements
              }
              break;
            default:
              break;
          }
        } catch (error) {
          reportError("tab indexing global banner carousel", error); // Log error using reportError function
        }
      };

      // Add event listeners
      window.addEventListener("keydown", handleKeyEvent);
      window.addEventListener("keyup", handleKeyEvent);

      // Clean up event listeners when the component unmounts or dependencies change
      return () => {
        window.removeEventListener("keydown", handleKeyEvent);
        window.removeEventListener("keyup", handleKeyEvent);
      };
    }, [tabPressed, isMobile]);

  const slides = props?.bannerMessages?.map((e,index)=>{
    let message = isMobile && e?.mobileMessage ? e?.mobileMessage: isTablet && e?.tabletMessage? e?.tabletMessage : e?.desktopMessage;
    let href = isMobile && e?.mobileMessageLink ? e?.mobileMessageLink: isTablet && e?.tabletMessageLink? e?.tabletMessageLink : e?.desktopMessageLink;
    return <a tabIndex={0} key={index} className={`x-small-md x-small-sm x-small-xs ${styles.slide}`} href={href}>{message}</a>
  })

  return(
    <div className={styles.global_banner}>
        <Slider {...settings} ref={sliderRef}>
          {slides}
        </Slider>
    </div>
  )
};

export default GlobalBannerCarousel;
